import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tracks"
export default class extends Controller {
  static outlets = ["track-player"]

  pause() {
    this.trackPlayerOutlets.filter(trackPlayer => trackPlayer.playingValue).forEach(trackPlayer => {
      trackPlayer.pause()
    })
  }
}
